import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class InquiriesQueryCriteriaClass extends BaseCriteriaModel {
  // from header
  issue_key?: Optional<string> = Optional.empty();
  title?: Optional<string> = Optional.empty();
  created_date_from?: Optional<string> = Optional.empty();
  created_date_to?: Optional<string> = Optional.empty();
  content_json?: Optional<string> = Optional.empty();
  guid_parent?: Optional<string> = Optional.empty();
  //for extension
  hdr_guid?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_file?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  extStatus?: Optional<string> = Optional.empty();
}

export class InquiriesCriteriaModelQuery {
  query = '';

  constructor(InquiriesCriteriaModel: InquiriesQueryCriteriaClass) {

    if (!InquiriesCriteriaModel) {
      return;
    }

    this.query += InquiriesCriteriaModel.issue_key.filter(x => x !== '').map(x => '&issue_key=' + x).orElse('');
    this.query += InquiriesCriteriaModel.title.filter(x => x !== '').map(x => '&title=' + x).orElse('');
    this.query += InquiriesCriteriaModel.created_date_from.filter(x => x !== '').map(x => '&created_date_from=' + x).orElse('');
    this.query += InquiriesCriteriaModel.created_date_to.filter(x => x !== '').map(x => '&created_date_to=' + x).orElse('');
    this.query += InquiriesCriteriaModel.content_json.filter(x => x !== '').map(x => '&content_json=' + x).orElse('');
    this.query += InquiriesCriteriaModel.guid_parent.filter(x => x !== '').map(x => '&guid_parent=' + x).orElse('');

    this.query += InquiriesCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += InquiriesCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += InquiriesCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += InquiriesCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += InquiriesCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += InquiriesCriteriaModel.value_file.filter(x => x !== '').map(x => '&value_file=' + x).orElse('');
    this.query += InquiriesCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += InquiriesCriteriaModel.extStatus.filter(x => x !== '').map(x => '&extStatus=' + x).orElse('');

    this.query += '&status=' + InquiriesCriteriaModel.status;
    this.query += '&orderBy=' + InquiriesCriteriaModel.orderBy;
    this.query += '&order=' + InquiriesCriteriaModel.order;
    this.query += '&offset=' + InquiriesCriteriaModel.offset + '&limit=' + InquiriesCriteriaModel.limit;
  }
}
